import axiosBasicInstance from '../axiosConfig';

const inviteEmail = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/invitation/email', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const accessInviteEmail = async (invitedId, data) => {
   try {
      const response = await axiosBasicInstance.post(`/invitation/access/${invitedId}`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const rejectInviteEmail = async (invitedId, data) => {
   try {
      const response = await axiosBasicInstance.post(`/invitation/reject/${invitedId}`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const detailInviteEmail = async (inviteId) => {
   try {
      const response = await axiosBasicInstance.post(`/invitation/detail/${inviteId}`);
      return response;
   } catch (error) {
      throw error;
   }
};

const inviteDecode = async (decodeToken) => {
   try {
      const response = await axiosBasicInstance.get(`/invitation/decode`, { headers: { 'X-Decode-Token': decodeToken } });
      return response;
   } catch (error) {
      throw error;
   }
};

const activeDecode = async (decodeToken) => {
   try {
      const response = await axiosBasicInstance.get(`/active/decode`, { headers: { 'X-Decode-Token': decodeToken } });
      return response;
   } catch (error) {
      throw error;
   }
};

const getinviteEmail = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/invitations/get-invations', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export {
  accessInviteEmail,
  inviteDecode,
  activeDecode,
  inviteEmail,
  getinviteEmail,
  rejectInviteEmail,
  detailInviteEmail,
};
